module.exports = __webpack_public_path__ + "static/media/Brands_2.034d0820.png";